export const CHECKOUT_URL =
  'https://mega-pack-tecnico-en-seguridad-electronica.impultienda.ar/checkout'

export const OFFER_ANCHOR = '#oferta'

export const SUPPORT_EMAIL = 'soportescmdigital@gmail.com'

export const PACK_IMAGE =
  'https://cdn.magicpatterns.com/uploads/6binbVZyXyXThQpym4zRLp/Imagen_de_Codex_23_sept_2026,_15_03_00.png'

export const PACK_IMAGE_ALT =
  'MEGA PACK TÉCNICO EN SEGURIDAD ELECTRÓNICA: 6 tomos digitales y 5 bonos incluidos'

export const PIXEL_ID = '2226605141499138'

export const PRODUCT_NAME = 'MEGA PACK TÉCNICO EN SEGURIDAD ELECTRÓNICA'
export const PRICE = '$19.990'
export const BONUS_TOTAL = '$39.950'

/* 1. PROBLEMA */
export const problems = [
  {
    emoji: '😵‍💫',
    title: 'INFORMACIÓN DISPERSA',
    desc: 'Guardas videos, diagramas y tutoriales de cámaras, alarmas y redes, pero cada uno explica algo diferente y no sabes cómo conectar todo.',
  },
  {
    emoji: '❓',
    title: 'NO SABES QUÉ APRENDER PRIMERO',
    desc: 'CCTV, alarmas, sensores, control de acceso, redes, cableado, porteros, PoE... hay tantos sistemas y conceptos que empezar parece complicado.',
  },
  {
    emoji: '🛡️',
    title: 'TE FALTA UNA RUTA',
    desc: 'Tienes ganas de aprender una habilidad técnica útil, pero necesitas un camino que vaya desde los fundamentos hacia la instalación, configuración y diagnóstico.',
  },
  {
    emoji: '😩',
    title: 'SIGUES POSTERGANDO',
    desc: 'Quieres comenzar, pero pasan las semanas y continúas buscando información en lugar de avanzar.',
  },
]

/* 2. SOLUCIÓN — 6 TOMOS */
export const tomos = [
  {
    title: 'FUNDAMENTOS TÉCNICOS Y HERRAMIENTAS',
    desc: 'Comprende electricidad básica aplicada, herramientas, medición, alimentación, cableado, conectores y los fundamentos necesarios antes de comenzar una instalación.',
  },
  {
    title: 'CCTV Y VIDEOVIGILANCIA',
    desc: 'Comprende cámaras, DVR, NVR, sistemas analógicos HD e IP, almacenamiento, PoE, instalación, configuración y diagnóstico inicial.',
  },
  {
    title: 'ALARMAS Y SEGURIDAD PERIMETRAL',
    desc: 'Aprende la lógica de centrales, sensores, contactos, sirenas, zonas, alimentación, respaldo, cercos eléctricos y diagnóstico de fallas frecuentes.',
  },
  {
    title: 'CONTROL DE ACCESO, PORTEROS Y VIDEOPORTEROS',
    desc: 'Comprende lectores, controladores, cerraduras, credenciales, sensores de puerta, porteros y videoporteros mediante diagramas y ejemplos prácticos.',
  },
  {
    title: 'REDES IP Y AUTOMATIZACIÓN',
    desc: 'Comprende direccionamiento IP, switches, routers, PoE, comunicación entre dispositivos, integración y fundamentos de automatización aplicada a seguridad electrónica.',
  },
  {
    title: 'DIAGNÓSTICO Y TÉCNICO PROFESIONAL',
    desc: 'Aprende a detectar fallas de forma ordenada, realizar mantenimiento, documentar instalaciones, organizar presupuestos y desarrollar un método profesional de trabajo.',
  },
]

/* 3. BONOS */
export const bonuses = [
  {
    title: 'MANUAL DE DIAGNÓSTICO RÁPIDO: 100 FALLAS Y SOLUCIONES™',
    desc: 'Una guía de campo para identificar síntomas, posibles causas, comprobaciones, soluciones y prevención de fallas habituales.',
    value: '$7.990',
  },
  {
    title: 'BIBLIOTECA PROFESIONAL DE DIAGRAMAS Y ESQUEMAS TÉCNICOS™',
    desc: 'Diagramas visuales de CCTV, alarmas, control de acceso, porteros, redes, alimentación y automatización para comprender cómo se relacionan los componentes.',
    value: '$5.990',
  },
  {
    title: 'KIT PROFESIONAL DEL INSTALADOR: 20 PLANTILLAS EDITABLES™',
    desc: 'Plantillas para clientes, relevamientos, materiales, presupuestos, órdenes de trabajo, instalaciones, mantenimiento, entrega y posventa.',
    value: '$6.990',
  },
  {
    title: 'CALCULADORA Y TABLAS DE CAMPO DEL TÉCNICO™',
    desc: 'Calculadoras, fórmulas y tablas prácticas para alimentación, consumo, baterías, almacenamiento CCTV, ancho de banda, PoE, redes y presupuestos.',
    value: '$8.990',
  },
  {
    title: 'DE TÉCNICO A PROFESIONAL™',
    desc: 'Una guía práctica para organizar tus servicios, presentar propuestas, conseguir oportunidades, presupuestar, atender clientes y desarrollar tu actividad profesional.',
    value: '$9.990',
  },
]

/* 4. BENEFICIOS */
export const benefits = [
  {
    emoji: '🛡️',
    title: 'MENOS CONFUSIÓN',
    desc: 'Deja de saltar entre videos y tutoriales y sigue una ruta desde los fundamentos hasta la instalación y el diagnóstico.',
  },
  {
    emoji: '🔧',
    title: 'MÁS CONOCIMIENTO PRÁCTICO',
    desc: 'Comprende cámaras, alarmas, accesos, porteros, redes, herramientas y sistemas mediante explicaciones claras y visuales.',
  },
  {
    emoji: '🏠',
    title: 'COMPRENDE LO QUE ESTÁS VIENDO',
    desc: 'Empieza a mirar una instalación, un equipo o un diagrama y reconocer qué componentes forman parte del sistema, cómo se relacionan y qué función cumplen.',
  },
  {
    emoji: '🚀',
    title: 'UNA NUEVA HABILIDAD',
    desc: 'Construye conocimientos técnicos que pueden convertirse en el primer paso para comenzar a ofrecer servicios de seguridad electrónica y seguir desarrollándote profesionalmente.',
  },
]

/* 5. TESTIMONIOS */
export const testimonials = [
  {
    quote:
      'Tenía videos guardados de cámaras, alarmas y redes, pero no sabía por dónde empezar. Con los tomos ordenados entendí primero los fundamentos y después cómo se conecta cada sistema. Ahora cuando veo una instalación entiendo mucho mejor qué estoy mirando.',
    author: 'Diego Fernández',
    role: 'Ayudante técnico, 27 años',
    location: 'Rosario, Argentina',
  },
  {
    quote:
      'Lo que más me sirvió fue entender CCTV desde una ruta ordenada. Antes escuchaba hablar de DVR, NVR, cámaras IP y PoE y mezclaba todo. Ahora puedo diferenciar cada tecnología y comprender cómo se relacionan los equipos.',
    author: 'Marcelo Ibáñez',
    role: 'Operario de mantenimiento, 41 años',
    location: 'Córdoba, Argentina',
  },
  {
    quote:
      'Necesitaba entender mejor los sistemas instalados en el edificio. Los módulos de alarmas, acceso y porteros me ayudaron a reconocer componentes y poder describir un problema con mucho más criterio.',
    author: 'Laura Quiroga',
    role: 'Encargada de edificio, 35 años',
    location: 'Montevideo, Uruguay',
  },
  {
    quote:
      'Compré buscando aprender una habilidad técnica y encontré una ruta completa. Lo que más me gustó fue que no se queda solamente en cámaras: también explica alarmas, acceso, redes y diagnóstico.',
    author: 'Cristian Molina',
    role: 'Emprendedor, 32 años',
    location: 'Santiago, Chile',
  },
  {
    quote:
      'Ya conocía algunas instalaciones, pero tenía todo aprendido por partes. Los diagramas, las tablas y las plantillas me ayudaron a ordenar mis conocimientos y entender mejor cómo trabajar de una forma más profesional.',
    author: 'Héctor Ramírez',
    role: 'Técnico en formación, 48 años',
    location: 'Guadalajara, México',
  },
]

/* 6. FAQ */
export const faqs = [
  {
    q: '¿Es físico o digital?',
    a: 'Es un producto 100% digital.',
  },
  {
    q: '¿Necesito conocimientos previos?',
    a: 'No. El sistema comienza desde los fundamentos técnicos y las herramientas básicas, para que avances paso a paso aunque empieces desde cero.',
  },
  {
    q: '¿Qué voy a aprender?',
    a: 'Fundamentos técnicos, CCTV y videovigilancia, alarmas y seguridad perimetral, control de acceso y porteros, redes IP y automatización, y diagnóstico con un método profesional de trabajo.',
  },
  {
    q: '¿Incluye ejercicios?',
    a: 'Sí. Los tomos incluyen diagramas, ejemplos y casos prácticos para aplicar lo aprendido, y los bonos suman tablas, calculadoras y plantillas para usar en campo.',
  },
  {
    q: '¿Los bonos tienen costo adicional?',
    a: 'No. Los 5 bonos, valorados en $39.950, están incluidos gratis con tu compra.',
  },
  {
    q: '¿Es un pago único?',
    a: 'Sí. Pagas $19.990 una sola vez, sin mensualidades ni cargos adicionales.',
  },
  {
    q: '¿Obtengo acceso inmediatamente?',
    a: 'Sí. Recibes el acceso digital a los 6 tomos y los 5 bonos después de confirmar tu compra.',
  },
  {
    q: '¿Esto me habilita profesionalmente?',
    a: 'No. Es un producto educativo: no sustituye formación profesional, certificaciones, licencias ni la normativa aplicable. Te da una base sólida para seguir desarrollándote.',
  },
  {
    q: '¿Puedo aprender a mi ritmo?',
    a: 'Sí. Al ser digital, estudias cuándo y dónde quieras, desde el celular, la tablet o la computadora.',
  },
  {
    q: '¿Dónde solicito soporte?',
    a: 'Escríbenos a soportescmdigital@gmail.com y te responderemos a la brevedad.',
  },
]

/* POP-UP DE COMPRAS RECIENTES — ARGENTINA */
export const recentBuyers = [
  { name: 'Martín Gómez', city: 'Córdoba', minutes: 2 },
  { name: 'Lucía Fernández', city: 'Rosario', minutes: 5 },
  { name: 'Pablo Sosa', city: 'Buenos Aires', minutes: 8 },
  { name: 'Andrés Medina', city: 'Mendoza', minutes: 12 },
  { name: 'Sofía López', city: 'La Plata', minutes: 16 },
  { name: 'Javier Ruiz', city: 'Mar del Plata', minutes: 21 },
  { name: 'Nicolás Benítez', city: 'Salta', minutes: 26 },
  { name: 'Camila Vera', city: 'Tucumán', minutes: 31 },
  { name: 'Gustavo Acosta', city: 'Neuquén', minutes: 37 },
  { name: 'Romina Paz', city: 'Santa Fe', minutes: 44 },
]
